/**
 * Route configuration for the application
 */

import { Navigate } from 'react-router';

import { GALLERY_ENABLED } from './constants/features.mjs';
import { AboutUs } from './pages/AboutUs/AboutUs';
import { CareGuide } from './pages/CareGuide/CareGuide';
import { Contact } from './pages/Contact/Contact';
import { CustomOrders } from './pages/CustomOrders/CustomOrders';
import { FAQ } from './pages/FAQ/FAQ';
import { Gallery } from './pages/Gallery/Gallery';
import { Home } from './pages/Home/Home';
import { NotFound } from './pages/NotFound/NotFound';
import { Policies } from './pages/Policies/Policies';
import { Privacy } from './pages/Privacy/Privacy';
import { ProductDetails } from './pages/ProductDetails/ProductDetails';
import { ProductListing } from './pages/ProductListing/ProductListing';
import { Terms } from './pages/Terms/Terms';
import { Wishlist } from './pages/Wishlist/Wishlist';

export const routes = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/products',
    element: <ProductListing />,
  },
  {
    path: '/products/:id',
    element: <ProductDetails />,
  },
  {
    path: '/wishlist',
    element: <Wishlist />,
  },
  {
    path: '/about-us',
    element: <AboutUs />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/custom-orders',
    element: <CustomOrders />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  ...(GALLERY_ENABLED
    ? [
        {
          path: '/gallery',
          element: <Gallery />,
        },
      ]
    : []),
  {
    path: '/care-guide',
    element: <CareGuide />,
  },
  {
    path: '/shipping-and-returns',
    element: <Policies />,
  },
  {
    path: '/policies',
    element: <Navigate to="/shipping-and-returns" replace />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];
